var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categorysList),function(category,key){return _c('div',{key:key,staticClass:"goods_category"},[_c('img',{attrs:{"src":require('assets/img/exchange/icon_body.png'),"alt":""}}),_c('div',{staticClass:"header_text"},[_vm._v(_vm._s(category.name))]),_c('Goods',{attrs:{"goodsList":category.goods}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }